import React from 'react';
import { Link } from 'react-router-dom';

export interface AboutProps {}

const About: React.FC<AboutProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1 style={{ marginLeft: -16 }}>Welcome</h1>
            <h3>I'm Pooja Choudhary</h3>
            <br />
            <div className="text-block">
                <p>
                    I'm a B.Ed-qualified teacher, certified through CTET,
                    India's national teacher-eligibility test for Classes 1–8,
                    and a graduate of Miranda House, University of Delhi.
                </p>
                <br />
                <p>
                    Thank you for taking the time to check out my portfolio. If
                    you have any questions or would like to work together, feel
                    free to contact me using{' '}
                    <Link to="/contact">this form</Link> or send me an email at{' '}
                    <a href="mailto:poojachoudharymh@gmail.com">
                        poojachoudharymh@gmail.com
                    </a>
                </p>
            </div>
            <div className="text-block">
                <h3>About Me</h3>
                <br />
                <p>
                    I'm a native Hindi speaker with professional English,
                    trained in lesson planning, child-centred teaching and
                    assessment. Six years of full-time civil-services exam study
                    gave me a strong grounding in social studies: history,
                    geography, civics and economics.
                </p>
                <br />
                <p>
                    I currently work part-time in a research and content role at
                    Leap Media, a video production studio. You can read more
                    about that on my <Link to="/experience">Experience</Link>{' '}
                    page.
                </p>
                <br />
                <p>
                    I'm looking for remote tutoring work in Hindi, social
                    studies and primary English, as well as education-content
                    work. I work remotely from India (IST, UTC+5:30), part-time
                    or on contract, and I'm available from 9 am to 9 pm IST.
                </p>
            </div>
            <div className="text-block">
                <h3>Skills</h3>
                <br />
                <ul>
                    <li>
                        <p>
                            <b>Teaching:</b> lesson planning, child-centred
                            teaching, classroom management, student assessment
                            and feedback, child development (B.Ed, CTET)
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Subjects:</b> Hindi language, social studies
                            (history, geography, civics, economics),
                            primary-level English
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Languages:</b> Hindi (native), English
                            (professional working proficiency), Malayalam (basic
                            comprehension)
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Tools:</b> Google Workspace, Microsoft Word and
                            Excel, Canva, Zoom, Google Meet, ChatGPT
                        </p>
                    </li>
                </ul>
            </div>
            <div className="text-block">
                <h3>Beyond Work</h3>
                <br />
                <p>
                    I write poetry and fiction in Hindi and English, and I
                    captained basketball teams at both school and college. You
                    can read more about both on my{' '}
                    <Link to="/activities">Activities</Link> page.
                </p>
                <br />
                <p>
                    Thanks for reading about me! If you have any questions or
                    comments I would love to hear them. You can reach me through
                    the <Link to="/contact">contact page</Link> or send me an
                    email at{' '}
                    <a href="mailto:poojachoudharymh@gmail.com">
                        poojachoudharymh@gmail.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default About;
